// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M22.5828 7.17043L16.8279 1.41553L12.4872 5.75656L18.2421 11.5115L22.5828 7.17043Z"},"nodeName":"path","children":[]},{"attributes":{"fill":"currentColor","d":"M16.8279 12.9257L11.073 7.17082L1.99976 16.2448L1.99976 21.9997L7.75469 21.9997L16.8279 12.9257Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-edit-1-filled')
export default class Edit1FilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'edit-1-filled',
    }
  }
}
